import React from 'react';
import { translate } from 'react-i18next';

import {colors} from 'style';
import Utils from 'utils/Utils.js';

const style={
    scroller:{
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        textAlign: 'center',
        paddingTop: '200px',
        paddingBottom: '100px',
    },
    container:{
        width: '100%',
        height: '100%',
    },
    segment: {
        maxWidth: '400px',
        height: '100%',
        textAlign: 'center',
        overflowY: 'auto',
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    title: {
        top: '10px',
        left: '0px',
        position: 'absolute',
        textAlign:'center',
        width: '100%',
        color: '#fff',
        textShadow: '1px 2px 1px rgba(0,0,0,0.25)',
        fontSize: '1.5em',
        zIndex: '1005',
    },
    bannerWrapper: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '150px',
        backgroundColor: '#fff',
    },
    banner: {
        width: '100%',
        height: '100%',
        maxWidth: '300px',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundRepeat:'no-repeat',
    },
    select: {
        backgroundColor: colors.themeBlue,
        color: '#fff',
        height: '70px',
        fontSize: '2em',
        lineHeight: '70px',
        width: '100%',
        position: 'absolute',
        bottom: '0',
        left: '0',
        cursor: 'pointer',
    },
    pointsLabel: {
        color: colors.themeBlue,
    },
    points: {
        color: colors.pointsYellow,
    },
    descriptionLabel: {
        fontWeight: 'bold',
        opacity: '0.9',
    },
    message: {
        opacity: '0.7',
    }
}

const SelectTeamConfirm = ({t, leaderboard, onConfirm}) => (
    <div style={style.scroller}>
        <div style={style.container}>
            <div style={style.segment}>
                {leaderboard && [
                <div key='0' style={style.bannerWrapper}>
                    <div style={{...style.banner, backgroundImage:Utils.url(leaderboard.banner.url)}} />
                </div>
                ,
                <div key='1' style={style.title}>{leaderboard.title}</div>
                ]}
                <div style={style.message}>{t('Invite 2 other Optimity members!')}</div>

                <br/>
                <br/>

                <div>
                    <div style={style.pointsLabel}>{t('Winning Team Bonus:')}</div>
                    <div style={style.points}><i className='icon-star'/> {leaderboard.points}</div>
                </div>
                <br />
                <div>
                    <div style={style.pointsLabel}>{t('Activity Points:')}</div>
                    <div style={style.points}><i className='icon-star'/> {leaderboard.challenge.points}</div>
                </div>
                <br />
                <div>
                    <div style={style.descriptionLabel}>{t('Instruction:')}</div>
                    <div style={style.message}>{leaderboard.challenge.description}</div>
                </div>

                <div style={style.select} onClick={onConfirm}>
                    {t('Select Team')}
                </div>
            </div>
        </div>
    </div>
);

export default translate('teamchallenges')(SelectTeamConfirm);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/SelectTeamConfirm.js